
import React, { useEffect, useState, useRef, useCallback } from "react";
// import './menuiteams.css';
import Modal from 'react-modal';
import { ShoppingCart } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { FaInfoCircle } from "react-icons/fa";
import './Ordercart.css';
import axios from 'axios';
import { useParams } from "react-router-dom"; // If using React Router
import { Button } from "react-bootstrap";
// import Payments from "./Payments";
import Paymentdata from "./Paymentdata";
import Tablepayment from "./Tablepayment";
import { useLocation as useRouteLocation } from "react-router-dom";

const suggestions = [
    'kphb Manjeera Trinity 3rd gate straight line',
];
// const Ordercart = ({ orderId }) => {
const Ordercart = ({ filteredDataProp = [], data }) => {
    // const [filteredData, setFilteredData] = useState(filteredDataProp);
    // const [quantities, setQuantities] = useState({});
    const [cartData, setCartData] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);  // ✅ Initialize state
    const [selectedService, setSelectedService] = React.useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [isEightModalOpen, setIsEightModalOpen] = useState(false);
    const [isTenModalOpen, setIsTenModalOpen] = useState(false);
    const [islevenModalOpen, setIslevenModalOpen] = useState(false);
    const [selectedDish, setSelectedDish] = useState(null); // Added missing state for selectedDish
    const navigate = useNavigate();
    const [selectedOffers, setSelectedOffers] = useState([]);
    const [userId, setUserId] = useState(localStorage.getItem("userId") || 3); // Use stored userId or default 1
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderData, setOrderData] = useState(null);
    // const [cartItems, setCartItems] = useState([]);
    const { id } = useParams(); // Get ID from URL (if using routing)
    // const [selectedDishId, setSelectedDishId] = useState(null); // Store the selected dishId
    const [inputValue, setInputValue] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedOrderType, setSelectedOrderType] = useState(null);
    const [savedDetails, setSavedDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [apiData, setApiData] = useState(null);
    const [coupons, setCoupons] = useState([]);

    const [total, settotal] = useState(0);
    const [discountAmount, setdiscountAmount] = useState(0);
    const [selectedCoupon, setSelectedCoupon] = useState(null); // Stores selected coupon details
    const [activeCategory, setActiveCategory] = useState("Allcarts");
    // const discount = 30;  // Fixed discount
    const deliveryCharge = 40; // or whatever amount you want
    const serviceCharge = 30; // Fixed service charge
    const taxRate = 0.06;
    // 6% CGST & SGST
    // const [loading, setLoading] = useState(false);
    const [showPaymentData, setShowPaymentData] = useState(false);
    const [filteredData, setFilteredData] = useState(filteredDataProp);
    const [refresh, setRefresh] = useState(false);
    const [displayData, setDisplayData] = useState([]);
    const [availableBalance, setAvailableBalance] = useState(0);
    const [availableCompany, setAvailableCompany] = useState(0);
    const [availableSelf, setAvailableSelf] = useState(0);
    const [availableCashback, setAvailableCashback] = useState(0);
    const [availableUsage, setAvailableUsage] = useState(0);

    // const [isCashChecked, setIsCashChecked] = useState(false);
    const [enteredAmount, setEnteredAmount] = useState("");
    const [gst, setGst] = useState(0);
    // const location = useLocation();
    // const [applied, setApplied] = useState(false); // Track if coupon is applied
    const [appliedCoupon, setAppliedCoupon] = useState(null);

    const [isWalletChecked, setIsWalletChecked] = useState(false);
    const [isCashChecked, setIsCashChecked] = useState(false);
    const [isOnlineChecked, setIsOnlineChecked] = useState(false);


    const vendorId = Number(localStorage.getItem("vendorId") || 42);  // Ensure vendorId is a number
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
    const [isPaymentOptionsVisible, setIsPaymentOptionsVisible] = useState(false);
    const [isPayNowSelected, setIsPayNowSelected] = useState(false);
    const [isOrderReviewModalOpen, setIsOrderReviewModalOpen] = useState(false);

    const routeLocation = useRouteLocation();
    const [addressDetails, setAddressDetails] = useState(null);
    const [showAddress, setShowAddress] = useState(false);
    const [category, setCategory] = useState(""); // This maps to "category"

    const [addresses, setAddresses] = useState([]);
    // const [selectedAddressId, setSelectedAddressId] = useState(null); // stores selected option from dropdown
    const [confirmedAddress, setConfirmedAddress] = useState(null);   // stores after Save button
    const [addressId, setAddressId] = useState(""); // Initialize with an empty string

    const [selectedAddressId, setSelectedAddressId] = useState(""); // Initialize to empty string
    const [categoryList, setCategoryList] = useState([]);
    const [cgstApply, setCgstApply] = useState("");
    const [sgstApply, setSgstApply] = useState("");

    const [showWalletOptions, setShowWalletOptions] = useState(false);
    const [selectedWalletType, setSelectedWalletType] = useState("");


    const [discount, setDiscount] = useState(0);
    // const [serviceCharges, setServiceCharges] = useState(0);

    const [packingChargesApply, setPackingChargesApply] = useState("");
    const [serviceChargesApply, setServiceChargesApply] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [subTotal, setSubTotal] = useState(0);
    const [gstTotal, setgstTotal] = useState(0);
    const [cgst, setCgst] = useState(0);
    const [sgst, setSgst] = useState(0);
    const [platformCharge, setPlatformCharge] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);

    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [orderId, setOrderId] = useState(null); // store orderId in state
    const [cartId, setCartId] = useState(null); // state for cartId
    const [serviceCharges, setserviceCharges] = useState("");
    const [platformCharges, setplatformCharges] = useState("");

    const [cartItems, setCartItems] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [sentItems, setSentItems] = useState({});
    const [tableCode, setTableCode] = useState("");


    const [showPopup, setShowPopup] = useState(false);
    const [notes, setNotes] = useState({});
    const [gstData, setGstData] = useState(null);
    // After fetching cartItems from your API
    const allReady = cartItems.length > 0 && cartItems.every(item => item.orderStatus === "COMPLETED");
    const [serviceApplied, setServiceApplied] = useState(true); // initially applied

    // ✅ Fetch cart details
    // 🟢 Add this with other states at the top of your component  
    const [packingCharges, setPackingCharges] = useState(0);
    const [deliveryCharges, setdeliveryCharges] = useState(0);

    useEffect(() => {
        if (appliedCoupon && discountAmount > 0 && allReady) {
            // open only when coupon applied AND all items completed
            setShowPaymentOptions(true);
        } else {
            // close otherwise
            setShowPaymentOptions(false);
        }
    }, [appliedCoupon, discountAmount, allReady]);

    // ✅ Load saved coupon & discount on mount
    useEffect(() => {
        const savedCoupon = localStorage.getItem("appliedCoupon");
        const savedDiscount = localStorage.getItem("discountAmount");

        if (savedCoupon) setAppliedCoupon(savedCoupon);
        if (savedDiscount) setdiscountAmount(Number(savedDiscount));
    }, []);

    // ✅ Save whenever they change
    useEffect(() => {
        if (appliedCoupon) {
            localStorage.setItem("appliedCoupon", appliedCoupon);
        } else {
            localStorage.removeItem("appliedCoupon");
        }

        localStorage.setItem("discountAmount", discountAmount);
    }, [appliedCoupon, discountAmount]);

    useEffect(() => {
        if (displayData.length > 0) {
            setCartId(displayData[0].cartId); // or however you determine cartId
        }
    }, [displayData]);

    const toggleServiceCharges = async (cartId) => {
        console.log("toggleServiceCharges called with cartId:", cartId);
        const token = localStorage.getItem("authToken"); // ✅ get token from localStorage
        if (!cartId) {
            console.error("Cart ID is missing. Cannot apply service charges.");
            alert("Cart ID is missing");
            return;
        }
        const newStatus = serviceApplied ? "NOT_APPLICABLE" : "APPLICABLE";
        try {
            setLoading(true);
            const response = await axios.put(
                ` https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
                {
                    serviceCharge: newStatus,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // ✅ include token in headers
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("✅ Service charge updated:", response.data);
            // ✅ Store new token if returned
            if (response.data?.token) {
                localStorage.setItem("authToken", response.data.token);
                console.log("🔐 Token updated in localStorage:", response.data.token);
            }
            // ✅ Re-fetch cart from backend
            await fetchCart();

        } catch (error) {
            console.error(
                "❌ Failed to update service charge:",
                error.response?.data || error.message
            );
            alert("Failed to update service charge. Try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleSendToChef = async (item) => {
        const note = notes[item.itemId] || "";
        const status = "CONFIRMED";
        const itemId = item.cartItemId || item.itemId;
        const token = localStorage.getItem('authToken'); // ✅ get token from localStorage

        if (!itemId) {
            console.error("❌ No valid cart item id found for:", item);
            return;
        }
        const url = ` https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}?status=${status}&note=${encodeURIComponent(note)}`;
        try {
            const response = await axios.put(url, null, {
                headers: {
                    Authorization: `Bearer ${token}`, // ✅ include token
                    "Content-Type": "application/json",
                }
            });
            console.log("✅ Sent to Chef:", response.data);
            alert(`Item ${item.dishName} sent with status ${status} and note "${note}"`);
            // Mark item as sent by itemId
            setSentItems(prev => {
                const updated = { ...prev, [itemId]: true };
                localStorage.setItem("sentItems", JSON.stringify(updated)); // save to localStorage
                return updated;
            });
        } catch (err) {
            console.error("❌ Error sending to chef:", err.response?.data || err.message);
        }
    };

    useEffect(() => {
        const stored = localStorage.getItem("sentItems");
        if (stored) {
            setSentItems(JSON.parse(stored));
        }
    }, []);

    useEffect(() => {
        fetchCart(); // ✅ moved out so we can reuse it
    }, []);

    const fetchCart = async () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        if (!userId) return;

        try {
            const response = await axios.get(
                ` https://backend.maamaas.com/food/api/cart/${userId}/with-seating`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // ✅ include token
                        "Content-Type": "application/json",
                    }
                });
            if (Array.isArray(response.data) && response.data.length > 0) {
                const cartData = response.data[0];

                // ✅ Save cartItems
                const items = cartData.cartItems || [];
                setCartItems(items);
                // ✅ Save tableCode
                setTableCode(cartData.tableCode || "");
                // ✅ Subtotals & Totals from backend
                setserviceCharges(cartData.serviceCharges || 0);
                setSubTotal(cartData.subtotal || "");
                setgstTotal(cartData.gstTotal || "");
                setGrandTotal(cartData.grandTotal || "");
                settotal(cartData.total || "");
                setdiscountAmount(cartData.discountAmount || "");
                // ✅ Build categories
                const categories = [...new Set(items.map((item) => item.dishName))];
                setAllCategories(["Allcarts", ...categories]);

                // ✅ Initialize quantities
                const initialQuantities = {};
                items.forEach((item) => {
                    initialQuantities[item.itemId] = item.quantity > 0 ? item.quantity : 1;
                });
                setQuantities(initialQuantities);

                // ✅ Track service applied
                setServiceApplied(cartData.serviceCharges > 0);
            }

            setLoading(false);
        } catch (error) {
            console.error("Error fetching cart:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (activeCategory === "Allcarts") {
            setFilteredItems(cartData);
        } else {
            const filtered = cartData.filter(item => item.dishName === activeCategory);
            setFilteredItems(filtered);
        }
    }, [activeCategory, cartData]);

    useEffect(() => {
        const storedCoupon = localStorage.getItem("appliedCoupon");
        if (storedCoupon) {
            setAppliedCoupon(JSON.parse(storedCoupon));
        }
    }, []);

    // Remove coupon function
    const handleRemoveCoupon = async () => {
        try {
            const cartId = localStorage.getItem("cartId");
            const appliedCoupon = JSON.parse(localStorage.getItem("appliedCoupon"));
            const token = localStorage.getItem("authToken");
            if (!cartId || !appliedCoupon?.id) {
                alert("❌ No cart or coupon found!");
                return;
            }
            const body = {
                id: Number(appliedCoupon.id),  // must send the coupon id
                applyCoupon: "NOT_APPLIED"     // enum for removal
            };
            const response = await axios.put(
                ` https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            console.log("✅ Coupon removed response:", response.data);
            // Clear local state and storage
            localStorage.removeItem("appliedCoupon");
            setAppliedCoupon(null);
        } catch (error) {
            console.error("❌ Failed to remove coupon:", error.response?.data || error.message);
            alert("Failed to remove coupon. Please try again.");
        }
    };

    useEffect(() => {
        const userId = Number(localStorage.getItem("userId"));
        const token = localStorage.getItem('authToken');
        if (!userId) {
            console.error("❌ User ID not found. User might not be logged in.");
            return;
        }
        axios
            .get(
                `https://backend.maamaas.com/subscription/api/user/wallet/${userId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            )
            .then((response) => {
                // console.log("✅ Full Balance Response:", response.data);
                const data = response.data;

                // ✅ Map to correct fields postPaidUsage
                 setAvailableBalance(data.totalBalance || 0);
                setAvailableCompany(data.companyLoadedAmount || 0);
                setAvailableSelf(data.selfLoadedAmount || 0);
                setAvailableCashback(data.cashbackAmount || 0);;
                // s
            })
            .catch((error) => {
                console.error("❌ Balance API Error:", error);
                setAvailableBalance(0);
                setAvailableCompany(0);
                setAvailableSelf(0);
                setAvailableCashback(0);
                setAvailableUsage(0);
            });
    }, []);

    const walletTypeMap = {
        self: "SELF_LOADED",
        company: "COMPANY_LOADED",
        cashback: "CASHBACK",
        // usage: "usage"
    };

    const handleCheckoutClickS = async () => {
        let userId = localStorage.getItem("userId");
        let token = localStorage.getItem("authToken"); // ✅ get stored token
        const mappedWalletType = walletTypeMap[selectedWalletType];

        console.log("Selected Wallet Type (Mapped):", mappedWalletType);

        if (!userId) {
            alert("User ID not found. Please log in again.");
            return;
        }
        if (selectedPaymentMethod === "Maamaas_Wallet" && !selectedWalletType) {
            alert("Please select a wallet type before creating the order.");
            return;
        }
        try {
            localStorage.removeItem("orderId"); // Clear previous order

            // ----------------- ONLINE PAYMENT -----------------
              if (selectedPaymentMethod === "Online_Payment") {
                const isRazorpayLoaded = await loadRazorpayScript();
                if (!isRazorpayLoaded) {
                    alert("❌ Razorpay SDK failed to load.");
                    return;
                }

                const amount = grandTotal;
                const amountInPaise = Math.round(amount);
                const username = 'rzp_live_RU5whSMu9rPV7s';      // replace with this rzp_live_RU5whSMu9rPV7s
                const password = 'FjLrs51Gf8Yq5OWT22CqamGF';
                const basicAuth = btoa(`${username}:${password}`);

                // Step 1: Create Razorpay order
                const orderResponse = await fetch(
                    " https://backend.maamaas.com/food/api/payments/create-order/user",
                    {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            amount: amountInPaise,
                            currency: "INR",
                            receipt: `order_${Date.now()}`,
                            notes: {
                                customer_name: savedDetails?.name || "John Doe",
                                order_reference: `WEB_ORDER_${Math.floor(Math.random() * 10000)}`,
                            },
                            partial_payment: false,
                            payment_capture: 0
                        }),
                    }
                );

                if (!orderResponse.ok) throw new Error("❌ Failed to create Razorpay order");
                const orderData = await orderResponse.json();
                console.log("🆔 Razorpay Order Created:", orderData);

                // Step 2: Open Razorpay checkout
                const options = {
                    key: "rzp_live_RU5whSMu9rPV7s",
                    amount: amountInPaise,
                    currency: "INR",
                    order_id: orderData.id || orderData.orderId,
                    name: "Maamaa's House",
                    description: "Order Payment",
                    prefill: {
                        name: savedDetails?.name || "Vamshi",
                        email: savedDetails?.email || "vamshikvky500@gmail.com",
                        contact: savedDetails?.mobileNumber || "9652030425",
                    },
                    theme: { color: "#3399cc" },
                    handler: async function (response) {
                        try {
                            console.log("✅ Payment Success Response:", response);

                            // Step 3: Capture Razorpay Payment
                            const captureRes = await fetch(
                                ' https://backend.maamaas.com/food/api/payments/capture',
                                {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${token}`,
                                    },
                                    body: JSON.stringify({
                                        paymentId: response.razorpay_payment_id,
                                        amount: amountInPaise,
                                        currency: "INR",
                                        orderId: orderData.id || orderData.orderId,
                                    }),
                                }
                            );

                            const rawText = await captureRes.text();
                            let captureData;
                            try { captureData = JSON.parse(rawText); }
                            catch { captureData = { raw: rawText }; }

                            if (!captureRes.ok) throw new Error("❌ Payment capture failed");

                            console.log("✅ Payment captured successfully!", captureData);

                            // Step 4: Place Order in backend with token
                            const responseOrder = await axios.post(
                                ` https://backend.maamaas.com/food/api/orders/orders/create/${localStorage.getItem("cartId")}`,
                                null,
                                {
                                    params: {
                                        userId,
                                        cartId: localStorage.getItem("cartId"),
                                        paymentMethod: "Online_Payment",
                                        walletType: null,
                                        razorpayPaymentId: response.razorpay_payment_id,
                                        razorpayOrderId: response.razorpay_order_id,
                                    },
                                    headers: {
                                        Authorization: `Bearer ${token}`,
                                        "Content-Type": "application/json",
                                    },
                                }
                            );

                            // Update token if backend returns a new one
                            if (responseOrder.data?.token) {
                                localStorage.setItem("authToken", responseOrder.data.token);
                                token = responseOrder.data.token;
                                console.log("🔐 Token updated in localStorage:", token);
                            }

                            if (responseOrder.status === 200 || responseOrder.status === 201) {
                                const newOrderId = responseOrder.data.orderId;
                                if (newOrderId) {
                                    localStorage.setItem("orderId", newOrderId);
                                    setOrderId(newOrderId);
                                }
                                setShowPaymentData(true);
                            } else {
                                alert("❌ Payment captured but order creation failed!");
                            }

                        } catch (err) {
                            console.error("❌ Error after payment:", err);
                            alert("❌ Payment succeeded but order failed.");
                        }
                    },
                };

                const paymentObject = new window.Razorpay(options);
                paymentObject.open();
                return;
            }

            // ----------------- OFFLINE / WALLET PAYMENT -----------------
            const orderResponse = await axios.post(
                ` https://backend.maamaas.com/food/api/orders/orders/create/${localStorage.getItem("cartId")}`,
                null,
                {
                    params: {
                        userId,
                        cartId: localStorage.getItem("cartId"),
                        paymentMethod: selectedPaymentMethod,
                        walletType: mappedWalletType || null,
                        razorpayPaymentId: "N/A",
                        razorpayOrderId: "N/A",
                    },
                    headers: {
                        Authorization: `Bearer ${token}`, // ✅ use token
                        Accept: "*/*",
                        "Content-Type": "application/json",
                    },
                }
            );
            // Update token if returned
            if (orderResponse.data?.token) {
                localStorage.setItem("authToken", orderResponse.data.token);
                token = orderResponse.data.token;
                console.log("🔐 Token updated in localStorage:", token);
            }
            console.log("Order API Response:", orderResponse.data);
            if (orderResponse.status === 200 || orderResponse.status === 201) {
                if (orderResponse.data?.orderId) {
                    localStorage.setItem("orderId", orderResponse.data.orderId);
                    setOrderId(orderResponse.data.orderId);
                }
                setShowPaymentData(true);
            } else {
                alert("⚠️ Failed to create order.");
            }

        } catch (error) {
            console.error("API error:", error.response?.data || error.message);
            alert("Failed to proceed to checkout.");
        }
    };

    const fetchCartDetails = () => {
        if (!userId) return;
        const token = localStorage.getItem("authToken");
        axios
            .get(
                ` https://backend.maamaas.com/food/api/cart/${userId}/with-seating`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // ✅ add token
                        "Content-Type": "application/json",
                    },

                }
            )
            .then((res) => {
                if (res.data) {
                    const data = res.data;
                    // ✅ Store cartId in state & localStorage
                    if (data.cartId) {
                        localStorage.setItem("cartId", data.cartId);
                        console.log("✅ Cart ID stored in localStorage:", data.cartId);
                    }

                    // setSubTotal(data.subtotal || 0);
                    setCgst((data.gstTotal || 0) / 2);
                    setSgst((data.gstTotal || 0) / 2);
                    setPlatformCharge(data.platformCharges || 0);
                    setPackingCharges(data.packingTotal || 0); // 🟢 Added line serviceCharges 
                    // setServiceCharges(data.serviceCharges || 0);
                    // setGrandTotal(data.grandTotal || 0);
                    setdeliveryCharges(data.deliveryCharges || 0);
                    setplatformCharges(data.platformCharges || 0);
                }
            })
            .catch((err) => {
                console.error("Error fetching price details:", err);
            });
    };

    useEffect(() => {
        fetchCartDetails();
    }, [userId, refresh]); // 🔁 refresh dependency
    //  const [isPaymentOptionsVisible, setIsPaymentOptionsVisible] = useState(false);
    const paymentRef = useRef(null);

    const handlePaymentClick = (type) => {
        setIsPayNowSelected(type === "payNow");
        setTimeout(() => {
            walletSectionRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);
    };
    const walletSectionRef = useRef(null);
    useEffect(() => {
        const flag = localStorage.getItem("showPaymentData") === "true";
        const service = localStorage.getItem("selectedService");
        const order = localStorage.getItem("orderData");

        if (flag && service && order) {
            setShowPaymentData(true);
            setSelectedService(service);
            setOrderData(JSON.parse(order));
        }

        // Optional: Clear after use
        localStorage.removeItem("showPaymentData");
        localStorage.removeItem("selectedService");
        localStorage.removeItem("orderData");
    }, []);
    useEffect(() => {
        const storedCoupon = JSON.parse(localStorage.getItem("couponData"));
        if (storedCoupon) {
            setAppliedCoupon(storedCoupon);
            setApplied(true);
        }
    }, []);

    React.useEffect(() => {
        const service = localStorage.getItem('selectedService');
        setSelectedService(service);
    }, []);
    // const cgst = 5;
    // const sgst = 5;
    const [billingData, setBillingData] = useState({});
    const originalDiscounts = billingData.discount || 0; // 1. define original
    const [discounts, setDiscounts] = useState(originalDiscounts); // 2. define state
    const originalDiscount = billingData.serviceCharges || 0;

    // const [packingCharge, setPackingCharge] = useState(0);
    const originalServiceCharge = billingData.serviceCharges || 0;
    const discountValue = parseFloat(originalDiscount) || 0;
    useEffect(() => {
        axios.get(" https://backend.maamaas.com/food/addresses/addresscategory")
            .then(response => {
                setCategoryList(response.data);
            })
            .catch(error => {
                console.error("Error fetching categories:", error);
            });
    }, []);

    useEffect(() => {
        console.log("Addresses array:", addresses); // Log to check if the addresses are loaded correctly
    }, [addresses]);

    useEffect(() => {
        const savedAddress = localStorage.getItem('selectedAddress');
        if (savedAddress) {
            const parsedAddress = JSON.parse(savedAddress);

            // Set the selected address in the state
            setConfirmedAddress(parsedAddress);
            setSelectedAddressId(parsedAddress.id); // Set the address ID
            setAddressDetails(parsedAddress); // Set the full address details
        }
    }, []);
    useEffect(() => {
        if (addressId) {
            axios.get(` https://backend.maamaas.com/food/addresses/getbyaddressid/${addressId}`)
                .then((response) => {
                    setAddressDetails(response.data);
                    setShowAddress(true);
                })
                .catch((error) => {
                    console.error("Error fetching address:", error);
                    setShowAddress(false);
                });
        }
    }, [addressId]);

    useEffect(() => {
        const fetchAddresses = async () => {
            try {
                const res = await axios.get(` https://backend.maamaas.com/food/addresses/all/${userId}`);
                setAddresses(res.data); // adjust this if the data is nested
            } catch (err) {
                console.error("Error fetching addresses:", err);
            }
        };

        if (userId) {
            fetchAddresses();
        }
    }, [userId]);
    const closeOrderReviewModal = () => {
        setIsOrderReviewModalOpen(false);
    };
    const [error, setError] = useState(null);
    const [walletData, setWalletData] = useState({
    });

    const handlePaymentClicks = (paymentType) => {
        if (paymentType === "payLater") {
            // Navigate to the DineInData component
            navigate("/dineindata"); // Assuming "/dinein" is the route for DineInData
        }
    };

    useEffect(() => {
        const fetchAddresses = async () => {
            try {
                const res = await axios.get(` https://backend.maamaas.com/food/addresses/all/${userId}`);

                if (res.data && Array.isArray(res.data) && res.data.length > 0) {
                    setAddressDetails(res.data[0]); // set the first address if available
                } else {
                    setAddressDetails(null);
                }
            } catch (err) {
                console.error("Error fetching addresses:", err);
            }
        };
        if (userId) {
            fetchAddresses();
        }
    }, [userId]);

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        const fetchWalletData = async () => {
            try {
                const response = await axios.get(` https://backend.maamaas.com/food/wallet/getwallet/${userId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-type": "Application/json"
                    }
                });
                const data = response.data;
                console.log("✅ Wallet Data:", data);
                // Save to local storage
                localStorage.setItem("walletData", JSON.stringify(data));

                // Set to state
                setWalletData(data);
            } catch (error) {
                console.error("❌ Failed to fetch wallet data:", error);
            }
        };

        if (userId) {
            fetchWalletData();
        }
    }, [userId]);
    // handleCheckboxChange((all the category of the products and all ))
    const handleCheckboxChange = async (e, method) => {
        const isChecked = e.target.checked;
        console.log(`Checkbox for ${method} is checked: `, isChecked);

        let newSelectedMethod = "";

        if (isChecked) {
            if (method === "wallet") {
                setIsWalletChecked(true);
                setIsCashChecked(false);
                setIsOnlineChecked(false);
                newSelectedMethod = "Maamaas_Wallet";
                setShowWalletOptions(true); // ✅ show options
            } else if (method === "cash") {
                setIsWalletChecked(false);
                setIsCashChecked(true);
                setIsOnlineChecked(false);
                newSelectedMethod = "Cash";
                setShowWalletOptions(false); // ✅ hide if not wallet
            } else if (method === "online") {
                setIsWalletChecked(false);
                setIsCashChecked(false);
                setIsOnlineChecked(true);
                newSelectedMethod = "Online_Payment";
                setShowWalletOptions(false); // ✅ hide if not wallet
            }
        } else {
            // Unchecking
            if (method === "wallet") {
                setIsWalletChecked(false);
                setShowWalletOptions(false); // ✅ hide when unchecked
            }
            if (method === "cash") setIsCashChecked(false);
            if (method === "online") setIsOnlineChecked(false);
            newSelectedMethod = "";
        }

        setSelectedPaymentMethod(newSelectedMethod);
        console.log("✅ Will set selectedPaymentMethod to:", newSelectedMethod);
    };

    const [applied, setApplied] = useState(() => {
        return localStorage.getItem("appliedCoupon") ? true : false;
    });

    // const coupon = location.state?.coupon; // Retrieve coupon data
    const coupon = routeLocation.state?.coupon || JSON.parse(localStorage.getItem("couponData")) || null;

    useEffect(() => {
        fetch(" https://backend.maamaas.com/food/coupon/coupon/1") // Replace with your GET API URL
            .then((response) => response.json())
            .then((data) => setCoupons(data))
            .catch((error) => console.error("Error fetching coupons:", error));
    }, []);

    // console.log("Location State:", location.state); // 🔍 Debugging
    // const navigate = useNavigate();
    useEffect(() => {
        const userId = Number(localStorage.getItem("userId"));
        const token = localStorage.getItem('authToken');
        if (!userId) {
            console.error("❌ User ID not found. User might not be logged in.");
            return;
        }
        // Fetching available balance  
        axios
            .get(` https://backend.maamaas.com/food/api/user/wallet/${userId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "Application/json",
                    }
                }
            )
            .then((response) => {
                console.log("✅ Full Balance Response:", response.data);
                const data = response.data;

                setAvailableBalance(data.totalBalance || 0);
                setAvailableCompany(data.companyLoadedAmount || 0);
                setAvailableSelf(data.selfLoadedAmount || 0);
                setAvailableCashback(data.cashbackAmount || 0);;
                // setAvailableUsage(data.postPaidUsage || 0);
            })
            .catch((error) => {
                console.error("❌ Balance API Error:", error);
                setAvailableBalance(0);
                setAvailableCompany(0);
                setAvailableSelf(0);
                setAvailableCashback(0);
            });
    }, []);

    useEffect(() => {
        // console.log("Updated displayData:", filteredDataProp);
        setDisplayData(filteredDataProp);
    }, [filteredDataProp]);

    useEffect(() => {
        const updateData = () => {
            const vendorId = localStorage.getItem("vendorId") || "1";
            const token = localStorage.getItem("authToken");

            if (filteredDataProp && Array.isArray(filteredDataProp) && filteredDataProp.length > 0) {
                setFilteredData(filteredDataProp);

                // Save only if not already stored (prevent quota issues)
                const currentStored = localStorage.getItem("cartItems");
                const newData = JSON.stringify(filteredDataProp);

                if (currentStored !== newData) {
                    try {
                        localStorage.setItem("cartItems", newData);
                    } catch (e) {
                        console.warn("🛑 Storage quota exceeded, not saving cartItems.");
                    }
                }
            }
        };
        updateData();
        const interval = setInterval(() => {
            setRefresh(prev => prev + 1);
            updateData();
        }, 1000); // ⬆ increased to 1000ms to avoid flooding
        return () => clearInterval(interval);
    }, [filteredDataProp, refresh]);

    useEffect(() => {
        const fetchCartData = async () => {
            const userId = localStorage.getItem("userId");
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            console.log("📦 userId:", userId);
            console.log("📦 vendorId:", vendorId);
            console.log("📦 token:", token);

            if (!userId || !vendorId) {
                console.error("🚨 userId or vendorId is missing!");
                return;
            }
            try {
                const response = await axios.get(
                    ` https://backend.maamaas.com/food/api/cart/${userId}`,
                    {
                        headers: token ? { Authorization: `Bearer ${token}` } : {},
                    }
                );

                console.log("📥 Full API Response:", response);

                const tokenFromHeader = response.headers['authorization'] || response.headers['Authorization'];
                if (tokenFromHeader) {
                    localStorage.setItem("authToken", tokenFromHeader);
                    console.log("🔐 Updated token from header");
                }
                if (response.data.token) {
                    localStorage.setItem("authToken", response.data.token);
                    console.log("🔐 Updated token from response body");
                }

                const cartItems = response.data.cartItems || [];
                console.log("🛒 Cart items:", cartItems);

                setCartData(cartItems);
                setFilteredItems(cartItems);

                const categories = [...new Set(cartItems.map(item => item.dishName))];
                setAllCategories(["Allcarts", ...categories]);
            } catch (error) {
                console.error("❌ Error fetching cart data:", error);
                if (error.response) {
                    console.error("📛 Response Error:", error.response.data);
                } else if (error.request) {
                    console.error("📛 No Response from server:", error.request);
                } else {
                    console.error("📛 General Error:", error.message);
                }
            }
        };

        fetchCartData();
    }, []);

    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    useEffect(() => {
        const storedOrderData = localStorage.getItem("orderData");
        const storedShowCheckout = localStorage.getItem("showCheckout");

        if (storedOrderData && storedShowCheckout === "true") {
            setOrderData(JSON.parse(storedOrderData));
            // setShowCheckout(true);

            // ✅ Clear `showCheckout` after showing it once
            localStorage.removeItem("showCheckout");
        }
    }, []);

    cartItems.reduce((acc, item) => ({ ...acc, [item.dishId]: item.quantity || 1 }), {})
    const incrementQuantity = async (item) => {
        if (!item?.itemId) {
            console.error("❌ Invalid itemId");
            return;
        }

        const token = localStorage.getItem("authToken"); // ✅ get token from localStorage
        const userId = localStorage.getItem("userId");
        if (!userId) {
            alert("Please log in to update items.");
            return;
        }
        const currentQty = quantities[item.itemId] || 0;
        const newQuantity = currentQty + 1;

        const updateQtyUrl = ` https://backend.maamaas.com/food/api/cart/update/${userId}?quantity=${newQuantity}&itemId=${item.itemId}`;
        console.log("📤 incrementQuantity PUT URL:", updateQtyUrl, "quantity:", newQuantity);
        try {
            // 1️⃣ Update quantity
            await axios.put(updateQtyUrl, null, {
                params: { quantity: newQuantity },
                headers: {
                    Authorization: `Bearer ${token}`, // ✅ include token
                    "Content-Type": "application/json",
                },
            });
            console.log(`✅ Item ${item.itemId} quantity updated to ${newQuantity}`);

            // 2️⃣ Update status to PENDING with note "hello"
            const status = "PENDING";
            const note = "hello";
            const statusUrl = ` https://backend.maamaas.com/food/api/cart/cartitem/status/${item.itemId}?status=${status}&note=${encodeURIComponent(note)}`;
            await axios.put(statusUrl, null, {
                headers: {
                    Authorization: `Bearer ${token}`, // ✅ include token here as well
                    "Content-Type": "application/json",
                },
            });
            console.log(`✅ Item ${item.itemId} status updated to ${status}`);

            // 3️⃣ Update local UI state
            setQuantities((prev) => ({
                ...prev,
                [item.itemId]: newQuantity,
            }));
            setDisplayData((prev) =>
                prev.map((i) =>
                    i.itemId === item.itemId
                        ? { ...i, quantity: newQuantity, status: status }
                        : i
                )
            );
            // 4️⃣ Reset "sent" status so Generate Bill button disables
            setSentItems((prev) => ({
                ...prev,
                [item.itemId]: false, // forces allSent = false
            }));
        } catch (err) {
            console.error(
                "❌ Error updating item quantity or status:",
                err.response?.data || err.message
            );
            alert("Unable to update cart right now. Please try again.");
        }
    };

    // Decrement Function
    const decrementQuantity = async (item) => {
        /* ── 1. Validate item ──────────────────────────────── */
        if (!item?.itemId) {
            console.error("❌ Invalid itemId");
            return;
        }
        const token = localStorage.getItem("authToken");
        const userId = localStorage.getItem("userId");
        if (!userId) {
            alert("Please log in to remove items.");
            return;
        }

        /* ── 2. Check quantity ─────────────────────────────── */
        const currentQty = quantities[item.itemId] || 0;
        if (currentQty === 0) return; // nothing to remove

        const newQuantity = currentQty - 1;

        /* ── 3. API request (Update quantity) ───────────────── */
        const apiUrl = ` https://backend.maamaas.com/food/api/cart/update/${userId}?quantity=${newQuantity}&itemId=${item.itemId}`;
        console.log("📤 decrementQuantity PUT URL:", apiUrl, "quantity:", newQuantity);

        try {
            await axios.put(apiUrl, null, {
                params: { quantity: newQuantity }, // Swagger expects ?quantity=...
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "Application/json",
                }
            });

            console.log(`✅ Item ${item.itemId} quantity updated to ${newQuantity}`);

            /* ── 4. Update local UI state ───────────────────── */
            if (newQuantity === 0) {
                setDisplayData((prev) => prev.filter((i) => i.itemId !== item.itemId));
                setQuantities((prev) => {
                    const q = { ...prev };
                    delete q[item.itemId];
                    return q;
                });
            } else {
                setQuantities((prev) => ({
                    ...prev,
                    [item.itemId]: newQuantity,
                }));
            }
            /* ── 5. Refresh cart ───────────────────────────── */
        } catch (err) {
            console.error(
                "❌ Error updating item quantity:",
                err.response?.data || err.message
            );
            alert("Unable to update cart right now. Please try again.");
        }
    };

    useEffect(() => {
        let isMounted = true;

        const vendorId = localStorage.getItem("vendorId") || "1";
        const token = localStorage.getItem("authToken");

        fetch(` https://backend.maamaas.com/food/api/cart/${userId}/with-seating`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (isMounted) {
                    console.log("Fetched Data:", data);
                    localStorage.setItem("cartItems", JSON.stringify(data)); // Store in localStorage
                    setItems(Array.isArray(data) ? data : []);
                }
            })
            .catch((error) => console.error("Error fetching data:", error));

        return () => {
            isMounted = false;
        };
    }, []);

    const handleClearCart = async () => {
        const userId = localStorage.getItem("userId"); // ✅ get userId
        const token = localStorage.getItem("authToken"); // ✅ get token

        if (!userId) {
            alert("User ID not found!");
            return;
        }
        const apiUrl = ` https://backend.maamaas.com/food/api/cart/delete/user/${userId}`;
        try {
            const response = await fetch(apiUrl, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`, // ✅ send token in headers
                    "Content-Type": "application/json",
                },
            });
            // ✅ Check if server returns a new token
            const data = await response.json().catch(() => null);
            if (data?.token) {
                localStorage.setItem("authToken", data.token); // 🔐 store new token if returned
                token = data.token;
                console.log("🔐 Token updated in localStorage:", data.token);
            }
            if (response.ok) {
                alert("Cart cleared successfully!");
                // Update UI state instead of reload if possible
                window.location.reload();
            } else {
                console.error("❌ Server Error:", data || response.statusText);
                alert("Failed to clear the cart.");
            }
        } catch (error) {
            console.error("⚠️ Error clearing cart:", error);
            alert("An error occurred while clearing the cart.");
        }
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 480);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Empty dependency array ensures this runs once when the component mounts
    const handleShowGST = async (userId) => {
        try {
            const response = await axios.get(
                ` https://backend.maamaas.com/food/api/cart/${userId}/with-seating`
            );

            const data = response.data;
            console.log("Fetched GST Data:", data); // Logs the full array
            // ✅ Extract first object from array
            const gstObj = Array.isArray(data) && data.length > 0 ? data[0] : {};
            const gstDetails = {
                serviceChargeGst: gstObj.serviceChargeGst ?? 0,
                platformChargeGst: gstObj.platformChargeGst ?? 0,
                cgst: gstObj.cgst ?? 0,
                sgst: gstObj.sgst ?? 0,
            };

            console.log("Extracted GST & Billing Details:", gstDetails);
            setGstData(gstDetails); // ✅ Save to state
            setShowPopup(true);     // ✅ Show popup
        } catch (err) {
            console.error("Error fetching GST data:", err);
        }
    };

    return (
        <div>
            {!showPaymentData ? (
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    {/* Button Section */}
                    {/* ===================  check Out code ============================================== */}
                    <div
                        style={{
                            overflowY: isMobile ? "none" : "auto",
                            scrollbarWidth: "none",
                            marginTop: "-50px",
                            height: "550px",
                        }}
                        className="carts1 carts-scroll-datass">
                        <>
                            <div>
                                <>
                                    <style>{`
        .order-wrapper {
          display: flex;
          flex-direction: column;
        //   padding: 5px;
           background: #ee6521;
          font-family: sans-serif;
         border-radius: 10px;
         margin-top:10px;
        }

        .order-container {
          background: #ee6521;
          border-radius: 10px;
          color: #fff;
          padding: 15px;
        //   margin-bottom: -298px;
        }

        .order-heading {
          font-weight: bold;
          text-align: center;
          font-size: 22px;
          margin-bottom: 15px;
        }

        .order-table-wrapper {
          overflow-x: auto;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 15px;
          font-weight: bold;
        }

        th, td {
          padding: 10px;
         
          text-align: center;
          font-size: 18px;
        }

        @media (max-width: 480px) {
            th, td {
                font-size: 8px;
            }
        }

        .quantity-box {
          display: flex;
          align-items: center;
          background: #fff;
          border-radius: 10px;
          width: 80px;
          margin: auto;
        }

        .quantity-box button {
          border: none;
          background: transparent;
          padding: 5px;
          cursor: pointer;
          color: #000;
          font-weight: bold;
          font-size:16px;
        }

        .quantity-box span {
          padding: 0 10px;
          font-weight: 800;
          color: #000;
        }

        .no-data {
          text-align: center;
          padding: 20px;
          font-weight: bold;
        }

        .total-section {
          background: #ee6521;
          border-radius: 10px;
          padding: 20px;
          color: white;
        }

        .pricedetails {
          display: flex;
        //   align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
        //   flex-wrap: wrap;
        }

        .pricedetails dt,
        .pricedetails dd {
          margin: 0;
          font-size:19px;
        }

        .pricedetails dd {
          min-width: 50px;
          text-align: right;
        }

        .total-button {
          padding: 4px 10px;
          width: 85px;
          height: 35px;
          cursor: pointer;
          border: none;
          border-radius: 10px;
          color: white;
          font-weight: bold;
        }

        hr {
          border: 2px solid #000;
          margin: 15px 0;
        }

        @media (max-width: 1200px) {
          .pricedetails {
            // flex-direction: column;
            align-items: flex-start;
          }
        }

        @media (max-width: 768px) {
          .pricedetails {
            // flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>

                                    <div className="order-wrapper">
                                        {/* Order Items Table */}
                                        <div className="order-container">
                                            <div style={{ position: "relative", textAlign: "center", marginBottom: "16px" }}>
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <h4 style={{ margin: 0, fontSize: "22px", fontWeight: "600" }}>
                                                        Table No: <span style={{ color: "#00b73b" }}>{tableCode || "-"}</span>
                                                    </h4>
                                                    <h4 style={{ margin: 0, fontSize: "22px", fontWeight: "600" }}>
                                                        Review your Cart
                                                    </h4>
                                                    <button
                                                        onClick={handleClearCart}
                                                        style={{
                                                            color: "red",
                                                            background: "#fff",
                                                            border: "none",
                                                            borderRadius: "4px",
                                                            cursor: "pointer",
                                                            fontSize: "18px",
                                                            padding: "4px 8px"
                                                        }}
                                                    >
                                                        Clear
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="order-table-wrapper">
                                                <table style={{ width: "100%", textAlign: "center", borderCollapse: "collapse" }}>
                                                    <thead>
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>Dish Name</th>
                                                            <th>Quantity</th>
                                                            <th>Price</th>
                                                            <th>Note</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredDataProp.length > 0 ? (
                                                            filteredDataProp.map((item, index) => (
                                                                <tr key={item.itemId} style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                    <td>{index + 1}</td>
                                                                    <td style={{ fontWeight: "bold" }}>{item.dishName}</td>
                                                                    <td>
                                                                        <div className="quantity-box">
                                                                            <button onClick={() => decrementQuantity({ ...item, itemId: item.itemId })}>-</button>
                                                                            <span>{quantities[item.itemId] || 0}</span> {/* use itemId */}
                                                                            <button onClick={() => incrementQuantity({ ...item, itemId: item.itemId })}>+</button>
                                                                        </div>
                                                                    </td>
                                                                    <td>₹{item.price?.toFixed(2)}</td>
                                                                    <td style={{ width: "173px" }}>
                                                                        <input
                                                                            type="text"
                                                                            placeholder="Add note..."
                                                                            value={notes[item.itemId] || ""}
                                                                            onChange={(e) =>
                                                                                setNotes((prev) => ({ ...prev, [item.itemId]: e.target.value }))
                                                                            }
                                                                            style={{
                                                                                width: "50%",
                                                                                padding: "6px 8px",
                                                                                borderRadius: "8px",
                                                                                border: "1px solid #ccc",
                                                                                outline: "none",
                                                                                fontSize: "14px",
                                                                                transition: "border-color 0.2s, box-shadow 0.2s",
                                                                            }}
                                                                            onFocus={(e) => (e.target.style.boxShadow = "0 0 5px #28a745")}
                                                                            onBlur={(e) => (e.target.style.boxShadow = "none")}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <button
                                                                            style={{
                                                                                backgroundColor: item.orderStatus === "PENDING" ? "#28a745" : sentItems[item.itemId] ? "#ccc" : "#28a745",
                                                                                color: "#fff",
                                                                                border: "none",
                                                                                padding: "6px 12px",
                                                                                borderRadius: "6px",
                                                                                cursor: item.orderStatus === "PENDING" ? "pointer" : sentItems[item.itemId] ? "not-allowed" : "pointer",
                                                                                fontWeight: "bold",
                                                                            }}
                                                                            onClick={() => handleSendToChef(item)}
                                                                            disabled={item.orderStatus !== "PENDING" && sentItems[item.itemId]}>                                      
                                                                            {sentItems[item.itemId] && item.orderStatus !== "PENDING" ? "Sent" : "Send"}
                                                                        </button>

                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="6">No data available</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            </div>
                            <div
                                style={{

                                    height: "65px",
                                    background: "#ee6521",
                                    borderRadius: "10px",
                                    marginTop: "20px",
                                    padding: "5px",
                                    color: "#fff",
                                }}>
                                <h3
                                    style={{
                                        fontWeight: "bold",
                                        display: "flex",
                                        justifyContent: "center",
                                    }}>
                                    <Link to="/tablemenu" style={{ textDecoration: "none", marginTop: "10px" }}>
                                        <p className="missed"> <span style={{ color: "#000" }}>Missed Something?</span> <span>Add More Items</span></p>
                                    </Link>
                                </h3>
                            </div>
                            {/* Internal CSS */}
                            <style>{`
        .payment-container {
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }

        .primary-btn {
            padding: 10px 20px;
            background-color: #ee6521;
            color: #fff;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            width: 150px;
            font-weight: bold;
            font-size: 20px;
        }

        .payment-options {
            margin-top: 20px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 30px;
        }

        .payment-options button {
            padding: 10px 20px;
            border: none;
            border-radius: 5px;
            width: 140px;
            font-weight: bold;
            font-size: 20px;
            cursor: pointer;
        }

        .pay-now {
            background-color: #4CAF50;
            color: #fff;
        }

        .pay-later {
            background-color: #f44336;
            color: #fff;
        }

        .method-box-container {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 20px;
            margin-top: 40px;
        }

        .method-box {
            flex: 1;
            min-width: 250px;
            // max-width: 30%;
            
            background: #ee6521;
            border-radius: 10px;
            display: flex;
            align-items: center;
            // padding: 0 20px;
            box-sizing: border-box;
        }

        .method-box input[type="checkbox"] {
            transform: scale(1.5);
            cursor: pointer;
        }

        .method-box h3 {
            margin-left: 15px;
            color: #fff;
            font-weight: bold;
            font-size: 18px;
        }

        .wallet-balance-btn {
            margin-left: auto;
            background: #fff;
            border: none;
            border-radius: 10px;
            font-weight: bold;
            padding: 8px 16px;
        }

        .checkout-container {
            display: flex;
            justify-content: center;
        }

        .checkout-btn {
            height: 40px;
            border: none;
            border-radius: 10px;
            background: #ee6521;
            color: #fff;
            font-weight: bold;
            font-size: large;
            margin-top: 10px;
            margin-bottom: 20px;
            padding: 0 30px;
        }

        /* Responsive for smaller screens */
        @media (max-width: 768px) {
            .method-box {
                max-width: 100%;
            }

            .payment-options {
                flex-direction: column;
                align-items: center;
                gap: 15px;
            }
        }
    `}</style>




                            {selectedOrderType === "Dine In" && (
                                <div className="row">
                                    <div className="col-12">
                                        {/* Place Order Button */}
                                        <div ref={paymentRef} className="payment-options">
                                            <button className="pay-now" onClick={() => handlePaymentClick("payNow")}>Pay Now</button>
                                            <button className="pay-later" onClick={() => handlePaymentClicks("payLater")}>Pay Later</button>
                                        </div>

                                        {/* Pay Now / Later */}
                                        {isPaymentOptionsVisible && (
                                            <div ref={walletSectionRef}>
                                                <div className="method-box-container">
                                                    {/* Wallet Box */}
                                                    <div className="method-box">
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => handleCheckboxChange(e, "wallet")}
                                                        />
                                                        <h3>Wallets</h3>
                                                        <button className="wallet-balance-btn">₹{availableBalance.toFixed(2)}</button>
                                                    </div>

                                                    {/* Cash Box */}
                                                    <div className="method-box">
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => handleCheckboxChange(e, "cash")}
                                                            checked={isCashChecked}
                                                        />
                                                        <h3>Cash</h3>
                                                    </div>

                                                    {/* Online Payment Box */}
                                                    <div className="method-box">
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => handleCheckboxChange(e, "online")}
                                                        />
                                                        <h3>Online Payment</h3>
                                                    </div>
                                                </div>

                                                {/* Checkout Button */}
                                                {/* Payment Data Display */}
                                                {showPaymentData && orderId && (
                                                    <Tablepayment applied={applied} orderId={orderId} />
                                                )}
                                            </div>
                                        )}
                                        {/* Payment Method Options */}

                                    </div>
                                </div>
                            )}
                        </>
                        <style>{`
        .payment-row {
  display: flex;
  justify-content: center;   /* center me rakhega */
  align-items: flex-start;   /* top se align */
  gap: 40px;                 /* dono boxes ke beech ka space */
  margin-top: 20px;
}

.method-box, .payment-box {
  background: #ee6521;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  width: 373px;              /* dono ka same width */
}

        .payment-box input[type="checkbox"] {
            transform: scale(1.5);
            cursor: pointer;
        }

        .payment-box h3 {
            margin-left: 15px;
            color: #fff;
            font-weight: bold;
            font-size: 18px;
        }

        .wallet-amount-btn {
            margin-left: auto;
            background: #fff;
            border: none;
            border-radius: 10px;
            font-weight: bold;
            padding: 8px 16px;
        }

        .checkout-wrapper {
            display: flex;
            justify-content: center;
        }

        .checkout-btn {
            height: 40px;
            border: none;
            border-radius: 10px;
            background: #ee6521;
            color: #fff;
            font-weight: bold;
            font-size: large;
            margin-top: -30px;
            margin-bottom: 20px;
            padding: 0 30px;
        }

        @media (max-width: 768px) {
            .payment-box {
                max-width: 100%;
            }
        }
    `}</style>
                        <div>
                            {/* Checkout button */}
                            <div className="checkout-wrapper" style={{ display: "flex", gap: "15px", marginTop: "40px" }}>
                                <button
                                    className="checkout-btn"
                                    onClick={() => setShowPaymentOptions(!showPaymentOptions)}
                                    disabled={!allReady}   // ⬅️ button disables if any item is not ready
                                    style={{
                                        backgroundColor: allReady ? "#28a745" : "#ccc",
                                        cursor: allReady ? "pointer" : "not-allowed",
                                        color: "#fff",
                                        padding: "8px 16px",
                                        border: "none",
                                        borderRadius: "6px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Generate Bill
                                </button>
                            </div>

                            {/* Show payment methods after Order Now */}
                            {showPaymentOptions && (
                                <div >
                                    <div
                                        style={{
                                            height: "auto",
                                            background: "#ee6521",
                                            padding: "15px",
                                            borderRadius: "10px",
                                            color: "#fff",
                                            fontWeight: "500",
                                        }}>
                                        <div className="total-section">
                                            <dl>
                                                <div className="pricedetails">
                                                    <dt>Sub Total</dt>
                                                    <dd>₹{subTotal}</dd>
                                                </div>

                                                <div className="pricedetails">
                                                    <dt>Platform Charges</dt>
                                                    <dd>₹{platformCharges}</dd>
                                                </div>
                                                {/* {serviceCharges > 0 && ( */}
                                                <div className="pricedetails">
                                                    <dt
                                                        onClick={() => {
                                                            const cartId = localStorage.getItem("cartId");
                                                            console.log("Calling toggleServiceCharges with cartId:", cartId);
                                                            toggleServiceCharges(cartId);
                                                        }}
                                                        style={{
                                                            cursor: "pointer",
                                                            padding: "4px 8px",
                                                            borderRadius: "5px",
                                                            border: "1px solid #ccc",
                                                            background: "rgb(242, 242, 242)",
                                                            fontWeight: "bold",
                                                            color: "#000",
                                                            fontSize: "15px",
                                                        }}>
                                                        Service Charges {serviceApplied ? "(Remove)" : "(Apply)"}
                                                    </dt>
                                                    <dd>₹{serviceCharges}</dd>
                                                </div>
                                                <div className="pricedetails" style={{ display: "flex", alignItems: "center" }}>
                                                    <dt>
                                                        GST
                                                        <FaInfoCircle
                                                            style={{ marginLeft: "8px", cursor: "pointer", color: "rgb(0 187 90)" }}
                                                            onClick={() => handleShowGST(userId)}
                                                        />
                                                    </dt>
                                                    <dd>₹{gstTotal}</dd>
                                                </div>
                                                {/* )} */}
                                                {packingCharges > 0 && (
                                                    <div className="pricedetails">
                                                        <dt>Packing Charges</dt>
                                                        <dd>₹{packingCharges}</dd>
                                                    </div>
                                                )}
                                                {deliveryCharges > 0 && (
                                                    <div className="pricedetails">
                                                        <dt>Delivery Charges</dt>
                                                        <dd>₹{deliveryCharges}</dd>
                                                    </div>
                                                )}
                                                {/* <div className="pricedetails">
                                                    <dt>Platform Charges</dt>
                                                    <dd>₹{platformCharge}</dd>
                                                </div> */}
                                                <hr />
                                                <div className="pricedetails" style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    <dt> Total</dt>

                                                    <dd>₹{total}</dd>
                                                </div>
                                                <div
                                                    className="pricedetails"
                                                    style={{ display: "flex", alignItems: "center", gap: "10px" }}
                                                >
                                                    {!appliedCoupon || discountAmount <= 0 ? (
                                                        // Show Apply button if no coupon OR discount is 0
                                                        <button
                                                            style={{
                                                                padding: "4px 8px",
                                                                fontSize: "13px",
                                                                cursor: "pointer",
                                                                borderRadius: "5px",
                                                                border: "1px solid #ccc",
                                                                background: "#f2f2f2",
                                                            }}
                                                            onClick={() =>
                                                                navigate("/profilepage", { state: { activeCategory: "Notifications" } })
                                                            }
                                                        >
                                                            Apply Discount
                                                        </button>
                                                    ) : (
                                                        // Show Remove + discount only when discountAmount > 0
                                                        <div
                                                            className="pricedetails"
                                                            style={{ display: "flex", alignItems: "center", gap: "5px" }}
                                                        >
                                                            <button
                                                                style={{
                                                                    padding: "4px 8px",
                                                                    fontSize: "13px",
                                                                    cursor: "pointer",
                                                                    borderRadius: "5px",
                                                                    border: "1px solid #ccc",
                                                                    background: "#f2f2f2",
                                                                }}
                                                                onClick={handleRemoveCoupon}
                                                            >
                                                                Remove
                                                            </button>
                                                            <dd>-₹{discountAmount}</dd>
                                                        </div>
                                                    )}
                                                </div>
                                            </dl>
                                        </div>
                                        <hr style={{ marginTop: "-10px" }} />
                                        <div className="pricedetails" style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                            <dt>Grand Total</dt>
                                            <dd>₹{grandTotal}</dd>
                                        </div>
                                    </div>
                                    {/* Payment Methods */}
                                    <div className="payment-row">
                                        {/* Wallet */}
                                        <div
                                            className="method-box"
                                            style={{ display: "flex", flexDirection: "column", gap: "36px" }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    marginTop: "10px",
                                                }}>
                                                <input
                                                    type="checkbox"
                                                    checked={isWalletChecked}
                                                    onChange={(e) => handleCheckboxChange(e, "wallet")}
                                                />
                                                <h3 style={{ margin: 0 }}>Wallet</h3>
                                                <button className="wallet-balance-btn">
                                                    ₹{Number(availableBalance).toFixed(2)}
                                                    
                                                </button>
                                            </div>
                                            {showWalletOptions && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "11px",
                                                        marginLeft: "-20px",
                                                    }}>
                                                    <label className="method-box">
                                                        <input
                                                            type="radio"
                                                            name="walletType"
                                                            value="company"
                                                            checked={selectedWalletType === "company"}
                                                            onChange={(e) => setSelectedWalletType(e.target.value)}
                                                        />
                                                        Company Loaded
                                                        <button className="wallet-balance-btn">
                                                            ₹{Number(availableCompany).toFixed(2)}
                                                        </button>
                                                    </label>
                                                    <label className="method-box">
                                                        <input
                                                            type="radio"
                                                            name="walletType"
                                                            value="self"
                                                            checked={selectedWalletType === "self"}
                                                            onChange={(e) => setSelectedWalletType(e.target.value)}
                                                        />
                                                        Self Loaded
                                                        <button className="wallet-balance-btn">
                                                            ₹{Number(availableSelf).toFixed(2)}
                                                        </button>
                                                    </label>
                                                    <label className="method-box">
                                                        <input
                                                            type="radio"
                                                            name="walletType"
                                                            value="cashback"
                                                            checked={selectedWalletType === "cashback"}
                                                            onChange={(e) => setSelectedWalletType(e.target.value)}
                                                        />
                                                        Cashback
                                                        <button className="wallet-balance-btn">
                                                            ₹{Number(availableCashback).toFixed(2)}
                                                        </button>
                                                    </label>
                                                    {/* <label className="method-box">
                                                        <input
                                                            type="radio"
                                                            name="walletType"
                                                            value="usage"
                                                            checked={selectedWalletType === "usage"}
                                                            onChange={(e) => setSelectedWalletType(e.target.value)}
                                                        />
                                                        Usage
                                                        <button className="wallet-balance-btn">
                                                            ₹{Number(availableUsage).toFixed(2)}
                                                        </button>
                                                    </label> */}
                                                </div>
                                            )}
                                        </div>

                                        {/* Cash */}
                                        {/* <div className="payment-box">
                                            <input
                                                type="checkbox"
                                                onChange={(e) => handleCheckboxChange(e, "cash")}
                                                checked={isCashChecked}
                                            />
                                            <h3>Cash</h3>
                                        </div> */}
                                        {/* Online */}
                                        <div className="payment-box">
                                            <input
                                                type="checkbox"
                                                onChange={(e) => handleCheckboxChange(e, "online")}
                                            />
                                            <h3>Online Payment</h3>
                                        </div>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                                        <button
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                backgroundColor: "#ee6521",
                                                color: "white",
                                                padding: "12px 30px",
                                                border: "none",
                                                borderRadius: "8px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                                                transition: "all 0.3s ease",
                                            }}
                                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#9e49c4")}
                                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#ee6521")}
                                            onClick={handleCheckoutClickS}>
                                            Check Out
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div >
                    {/* ===================================== GST POP UP DATA =============================================================== */}
                    {showPopup && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: "rgba(0, 0, 0, 0.6)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 999,
                                animation: "fadeIn 0.3s ease-in-out",
                            }}>
                            <div
                                style={{
                                    background: "linear-gradient(135deg, #ffffff, #f8f9fa)",
                                    padding: "25px",
                                    borderRadius: "12px",
                                    width: "350px",
                                    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                                    textAlign: "center",
                                    animation: "scaleUp 0.3s ease-in-out",
                                }}>
                                <h3 style={{ marginBottom: "15px", color: "#333", fontSize: "20px" }}>
                                    GST Breakdown
                                </h3>
                                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>Service Charge GST:</strong> ₹{gstData.serviceChargeGst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>Platform Charge GST:</strong> ₹{gstData.platformChargeGst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>CGST:</strong> ₹{gstData.cgst}
                                    </li>
                                    <li style={{ margin: "8px 0", fontSize: "16px", color: "#444" }}>
                                        <strong>SGST:</strong> ₹{gstData.
                                            sgst
                                        }
                                    </li>
                                </ul>
                                <button
                                    onClick={() => setShowPopup(false)}
                                    style={{
                                        marginTop: "20px",
                                        padding: "10px 18px",
                                        background: "linear-gradient(90deg, #007bff, #0056d2)",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                    }}
                                    onMouseOver={(e) =>
                                    (e.target.style.background =
                                        "linear-gradient(90deg, #0056d2, #003c99)")
                                    }
                                    onMouseOut={(e) =>
                                    (e.target.style.background =
                                        "linear-gradient(90deg, #007bff, #0056d2)")
                                    }>
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div >
            ) : (
                <Tablepayment />
            )
            }
        </div >
    );
};

export default Ordercart;